import { html } from 'lit';

export function getMarginMarkupHelpPage() {
  return html`<div class="marginmarkup-container">
    <div class="mm-hero">
      <span class="mm-hero-eyebrow">Pricing reference</span>
      <h2 class="mm-hero-title">Markup vs. Margin</h2>
      <p class="mm-hero-sub">Two ways to express the same profit. Know which one you are setting.</p>
    </div>

    <div class="mm-body">
      <section class="mm-block">
        <h3 class="mm-block-title">Terminology</h3>
        <dl class="mm-terms">
          <div class="mm-term">
            <dt>Revenue</dt>
            <dd>Earnings before deducting costs.</dd>
          </div>
          <div class="mm-term">
            <dt>COGS</dt>
            <dd>Cost of goods sold: what it costs to create the sales items.</dd>
          </div>
          <div class="mm-term">
            <dt>Gross Profit</dt>
            <dd>Revenue minus COGS.</dd>
          </div>
        </dl>
      </section>

      <section class="mm-block">
        <h3 class="mm-block-title">The two formulas</h3>
        <div class="mm-cards">
          <webmodule-card class="mm-card mm-card--margin">
            <span class="mm-card-tag">Margin</span>
            <p class="mm-card-desc">Profit as a share of the <strong>selling price</strong>.</p>
            <code class="mm-eq">Gross Profit ÷ Revenue × 100</code>
          </webmodule-card>
          <webmodule-card class="mm-card mm-card--markup">
            <span class="mm-card-tag">Markup</span>
            <p class="mm-card-desc">Profit as a share of the <strong>cost</strong>.</p>
            <code class="mm-eq">Gross Profit ÷ Cost × 100</code>
          </webmodule-card>
        </div>
      </section>

      <section class="mm-block">
        <h3 class="mm-block-title">Worked example</h3>
        <p class="mm-block-note">A $200 sale that cost you $150, so $50 gross profit.</p>
        <div class="mm-cards">
          <webmodule-card class="mm-card mm-card--margin">
            <span class="mm-card-tag">Margin</span>
            <ol class="mm-steps">
              <li><span>Gross profit</span><code>$200 − $150 = $50</code></li>
              <li><span>Divide by revenue</span><code>$50 ÷ $200 = 0.25</code></li>
            </ol>
            <div class="mm-result">= 25% margin</div>
          </webmodule-card>
          <webmodule-card class="mm-card mm-card--markup">
            <span class="mm-card-tag">Markup</span>
            <ol class="mm-steps">
              <li><span>Gross profit</span><code>$200 − $150 = $50</code></li>
              <li><span>Divide by cost</span><code>$50 ÷ $150 = 0.33</code></li>
            </ol>
            <div class="mm-result">= 33% markup</div>
          </webmodule-card>
        </div>
      </section>

      <section class="mm-block">
        <h3 class="mm-block-title">Quick comparison</h3>
        <table class="mm-table">
          <thead>
            <tr>
              <th>Margin</th>
              <th>Markup</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>13%</td>
              <td>15%</td>
            </tr>
            <tr>
              <td>16.7%</td>
              <td>20%</td>
            </tr>
            <tr>
              <td>20%</td>
              <td>25%</td>
            </tr>
            <tr>
              <td>23%</td>
              <td>30%</td>
            </tr>
            <tr>
              <td>25%</td>
              <td>33.33%</td>
            </tr>
            <tr>
              <td>28.6%</td>
              <td>40%</td>
            </tr>
            <tr>
              <td>30%</td>
              <td>43%</td>
            </tr>
            <tr>
              <td>33%</td>
              <td>50%</td>
            </tr>
            <tr>
              <td>42.9%</td>
              <td>75%</td>
            </tr>
            <tr>
              <td>50%</td>
              <td>100%</td>
            </tr>
          </tbody>
        </table>
      </section>
    </div>
  </div>`;
}
